import { z } from "zod";

import { responseDetailSchema, multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Other Weight Management History validation schema
 * Validates the entire otherWeightManagementHistory category
 */

export const otherWeightManagementHistoryValidation = z.object({
  medicalHistory: z.array(z.string()).min(1, "Please select at least one option"),
  type2Diabetes: z.boolean(),
  diabetesMedications: z.array(multiSelectResponseSchema),
  checkBloodSugar: z.boolean().nullable(),
  eyeDisease: responseDetailSchema,
  gastrointestinalProblems: z.array(z.string()).min(1, "Please select at least one option"),
  stomachOrBowelSurgery: responseDetailSchema,
  upcomingSurgeries: responseDetailSchema,
  femaleHistory: z.array(z.string()).min(1, "Please select at least one option"),
});

export default otherWeightManagementHistoryValidation;
